import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import CloverleafImage from "../Main/image/Cloverleaf.png";
import Grid from "@mui/material/Grid/Grid";
import { TextField } from '@mui/material';
import SignUpUserImage from '../Main/image/SignUpUser.png';
import { useStore } from '../../state/MobxContext';
import { useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';



function SignUpDialog() {
    // const { SignUpStore } = useStore();
    const { loginStore } = useStore();
    // const navigate = useNavigate();
    const inputRef = useRef(null);


    const useStyles = makeStyles({
        //Dialog
        Dialog: {
            width: '350px',
            height: "600px"
        },
        DialogMobile: {
            height: '100%',
            width: '100%',
            minWidth: "320px",
            position: 'absolute',
            top: '-0',
            left: '0',
        },
    });

    const ProfileClick = () => {
        inputRef.current.click();
    };


    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 600px)");
    const SignUP = loginStore?.isSignUpButtonAction;
    const GuideRecommenderColor = loginStore?.GuideRecommenderColor;
    const GuideNicknameColor = loginStore?.GuideNickNameColor;
    const NicknameCheckButtonColor = loginStore?.NicknameCheckButtonColor;
    const RecommenderCheckButtonColor = loginStore?.RecommenderCheckButtonColor;
    const member_nickname = loginStore?.loginState?.member_nickname;
    const Guide_clover_profile = loginStore?.Guide_clover_profile;
    const Guide_clover_memberShip = loginStore?.Guide_clover_memberShip;
    const Guide_clover_memberImage_Button = loginStore?.Guide_clover_memberImage_Button;
    const GuideLabel_clover_nickName = loginStore?.GuideLabel_clover_nickName;
    const GuideLabel_clover_recommender = loginStore?.GuideLabel_clover_recommender;
    let UserCountry = loginStore.Usercountry;
    // let UserCountry = "US"; //Test

    // console.log(UserCountry);


    // console.log(member_nickname.length);

    const WhiteTextTypography = withStyles({
        root: {
            color: "#FFFFFF",
            fontSize: "1.5rem"

        }
    })(Typography);


    // classes={ isMobile? {paper: classes.DialogMobile} : {paper: classes.Dialog} }



    return (
        <div style={{fontSize:'10px'}}>
            <Dialog fullScreen={isMobile ? true : false} minheight="xs" classes={isMobile ? { paper: classes.DialogMobile } : { paper: classes.Dialog }} maxWidth="xl" open={loginStore?.isSignUpDialogOpen} onClose={loginStore.setDialogClose} >
                <Box maxWidth='xl' minheight="xs" sx={{ display: 'flex', bgcolor: 'black', width: '100%', maxWidth: 500, height: 70 }}>
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='space-between' alignItems='center' >
                        <Grid container item xs={11} sm={11} md={11} lg={11} xl={11} alignItems="flex-end"  >
                            <img src={CloverleafImage} width="50" height="50" alt="Cloverleaf" />
                            <WhiteTextTypography > {Guide_clover_memberShip} </WhiteTextTypography>
                        </Grid>
                        <Grid container item xs={1} sm={1} md={1} lg={1} xl={1}>
                            {member_nickname === undefined || member_nickname === null || member_nickname.length === 0 ?
                                <div>
                                </div>
                                :
                                <FontAwesomeIcon icon={faXmark} color='White' size='2x' onClick={(e) => { loginStore.setDialogClose("SignupFalse") }} />
                            }
                        </Grid>

                    </Grid>
                </Box>
                {/* 작업끝 */}
                <DialogContent >
                    <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='column' justifyContent='center' alignItems='center' spacing={5}>
                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                            <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='center' marginBottom='-20px'>
                                <Typography variant='h5' >{Guide_clover_profile}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                            <Box maxWidth='xl' sx={{ display: 'flex', border: 1, borderColor: "brack" }}>
                                <div style={{ position: 'relative', }} >
                                    <div className='img-box' />
                                    {loginStore?.SignUpImage ? <img src={loginStore?.SignUpImage} alt='SignUpImage' width="180" height="180" />
                                        :
                                        <img src={SignUpUserImage} width="180" id='profile-Image' height="180" alt="UserImage" />
                                    }
                                    <div style={UserCountry !== "KR" ? { position: 'absolute', left: 93, top: 161 } : { position: 'absolute', left: 137, top: 161 }} >
                                        <button form='profileImage' id='ProfileImagebutton' variant="outlined" style={{fontSize:"0.84rem"}} onClick={ProfileClick} >{Guide_clover_memberImage_Button}</button>
                                    </div>
                                </div>
                            </Box>
                            <input type="file" name='profileImage' onChange={loginStore.setSignUpImage} variant="standard" ref={inputRef} id='profileImage' style={{ display: 'none' }} />
                            <label htmlFor='profileImage' color='red' >{loginStore?.GuideNickImage}</label>
                        </Grid>
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-start'>
                            <TextField
                                style={isMobile ? { maxWidth: '180px', maxHeight: '30px', minWidth: '150px', minHeight: '30px', marginTop: "-25px" }
                                    : { maxWidth: '160px', maxHeight: '0px', minWidth: '150px', minHeight: '0px', marginTop: "-25px" }}
                                id=""
                                label={GuideLabel_clover_nickName}
                                variant="standard"
                                defaultValue={member_nickname == undefined || member_nickname == null || member_nickname == "" ? "" : member_nickname}
                                FormHelperTextProps={isMobile ?
                                    { min: 0, style: { textAlign: 'center', fontSize: 10, color: GuideNicknameColor } }
                                    : { min: 0, style: { textAlign: 'center', fontSize: 10, color: GuideNicknameColor } }}

                                onChange={loginStore.setSignUpNickname}
                                helperText={loginStore?.GuideNickName}
                            />
                            <FontAwesomeIcon icon={faCircleCheck} color={NicknameCheckButtonColor === true ? '#66bb6a' : '#ef5350'} size='xl' onClick={(e) => { loginStore.setCheckNickName() }}> </FontAwesomeIcon>
                        </Grid>
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-start'>
                            <TextField
                                style={isMobile ? { maxWidth: '180px', maxHeight: '30px', minWidth: '150px', minHeight: '30px', marginTop: "-25px" }
                                    : { maxWidth: '160px', maxHeight: '30px', minWidth: '150px', minHeight: '30px', marginTop: "-25px" }}
                                id=""
                                label={GuideLabel_clover_recommender}
                                variant="standard"
                                defaultValue=""
                                FormHelperTextProps={isMobile ?
                                    { min: 0, style: { textAlign: 'center', fontSize: 10, color: GuideRecommenderColor } }
                                    : { min: 0, style: { textAlign: 'center', fontSize: 10, color: GuideRecommenderColor } }}
                                onChange={loginStore.setSignUpRecommender}
                                helperText={loginStore?.GuideRecommender}
                            />
                            <FontAwesomeIcon icon={faCircleCheck} className={classes.Buttons} color={RecommenderCheckButtonColor === true ? '#66bb6a' : '#ef5350'} size='xl' onClick={(e) => { loginStore.setCheckRecommender() }}> </FontAwesomeIcon>
                        </Grid>
                        <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} direction='row' justifyContent='center' alignItems='flex-start'>
                            <Button style={isMobile ? { maxWidth: '200px', maxHeight: '50px', minWidth: '200px', minHeight: '50px', fontSize: 20 }
                                : { maxWidth: '220px', maxHeight: '50px', minWidth: '220px', minHeight: '50px', fontSize: 20 }} size="small"
                                onClick={(e) => { loginStore.setSignUp() }} disabled={SignUP !== false ? false : true} variant="contained" >{Guide_clover_memberShip}</Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default observer(SignUpDialog);